import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Button, Flex, Table } from "antd"
import { choose } from "choose-matching"

import { notify } from "@src/app/components/notify"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { GlobalPayoutsConformationProcess } from "@src/pages/payoutsConfirmation/classes/PayoutsConformationProcess"
import {
  massPayoutCardColumns,
  massPayoutCryptoColumns,
} from "@src/pages/payoutsConfirmation/constants"
import {
  CardMassPayoutResponsePayouts,
  MassPayoutResponsePayouts,
} from "@src/shared/api/generated"
import { FormOTP } from "@src/shared/componemts/FormOTP"
import css from "./index.module.css"

export const PayoutsConfirmationPage = observer(() => {
  const navigate = useNavigate()

  const [isOtpOpen, setIsOtpOpen] = useState(false)

  const process = GlobalPayoutsConformationProcess()

  const onOtpSubmit = async (otp: string) => {
    return process.confirm(otp).then(() => {
      navigate(-1)

      notify.success("Funds have been sent")
    })
  }

  useEffect(() => () => process.reset(), [])

  const handleCancel = () => {
    process.cancel().then(() => navigate(-1))
  }

  const table = computed(() => {
    return {
      card: (
        <Table
          columns={massPayoutCardColumns}
          dataSource={process.payouts as CardMassPayoutResponsePayouts[]}
        />
      ),
      crypto: (
        <Table
          columns={massPayoutCryptoColumns}
          dataSource={process.payouts as MassPayoutResponsePayouts[]}
        />
      ),
    }[process.type]
  }).get()

  return (
    <DefaultPageLayout
      {...(isOtpOpen
        ? { backAction: () => setIsOtpOpen(false), title: "2FA check" }
        : {
            backAction: () => navigate(-1),
            title: "Payouts",
            url: paths.manualPayouts,
          })}
    >
      <>
        {choose(
          [
            isOtpOpen,
            <FormOTP onSubmit={onOtpSubmit} setVisible={setIsOtpOpen} />,
          ],
          [
            true,
            <Flex gap={32} vertical>
              {table}

              <div className={css.buttonsWrapper}>
                <Button
                  ghost
                  id="GENERATED_ID_PAYOUTSCONFIRMATION_BUTTON_CANCEL_1"
                  onClick={handleCancel}
                  size="large"
                  type="primary"
                >
                  Cancel
                </Button>
                <Button
                  id="GENERATED_ID_PAYOUTSCONFIRMATION_BUTTON_SEND_FUNDS_1"
                  onClick={() => setIsOtpOpen(true)}
                  size="large"
                  type="primary"
                >
                  Send funds
                </Button>
              </div>
            </Flex>,
          ],
        )}
      </>
    </DefaultPageLayout>
  )
})
